module.exports = __webpack_public_path__ + "static/media/09.f62eb4bf.jpg";